import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var DDP_ENV: any;

@Injectable()
export class ClientService {
base_url = DDP_ENV.userServiceUrl;
constructor(private _router: Router, private _http: Http, private cookieService: CookieService) {}

/* Get clients by client_id */
getClientByClientId(client_id: string): Observable<any> {
return this._http.get(this.base_url + '/client/' + client_id, this.buildHeaders())
  .map((res: Response) => res.json());
}

/* Get clients by client_id */
/*	getClientByClientId(client_id: string) : Observable<any>{
		return this._http.get(this.base_url + "/client/" + client_id, this.buildHeaders())
		               .map((res:Response) => res.json());
	}*/

private buildHeaders(): any {
  const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
  return new RequestOptions({ headers: headers });
}

}
